import { Button } from '@mui/material';
import { useMutation } from '@tanstack/react-query';

import { ConfirmationDialog, api, parseError, useToast } from 'common';

interface AgenticChatDeleteDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDeleted: () => void;
  sessionId: string;
  title: string;
}

export function AgenticChatDeleteDialog(props: AgenticChatDeleteDialogProps) {
  const { isOpen, onClose, onDeleted, sessionId, title } = props;
  const toast = useToast();
  const deleteSessionMutation = useMutation({
    mutationFn: async () => await api.client.AgenticPlatformSession.delete(sessionId),
  });

  return (
    <ConfirmationDialog
      title="Delete conversation?"
      open={isOpen}
      onClose={() => onClose()}
      actions={
        <>
          <Button variant="outlined" onClick={() => onClose()}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            loading={deleteSessionMutation.isPending}
            onClick={async () => {
              try {
                await deleteSessionMutation.mutateAsync();
                onDeleted();
                onClose();
              } catch (error) {
                toast.showError(`Error while deleting conversation: ${parseError(error)}`);
              }
            }}
          >
            Delete
          </Button>
        </>
      }
    >
      {`“${title}” will no longer be listed, and its history will not be shown again.`}
    </ConfirmationDialog>
  );
}
